import { FC, ReactNode } from "react";

import { Shelf } from "../../layout";

import { Button, ButtonAppearance, Buttons } from "../Button";
import { Modal, ModalProps } from "./Modal";

/**
 * The `ConfirmModal` component properties.
 */
export interface ConfirmModalProps extends Omit<ModalProps, "footer"> {
  /**
   * The content within the confirm button. If not specified defaults to "Okay".
   */
  readonly confirmContent?: ReactNode;

  /**
   * The button appearence type for the primary "appove" button. Defaults to "Functional"
   */
  readonly confirmButtonAppearance?: ButtonAppearance;
}

/**
 * A component which displays a Modal dialog box.
 */
export const ConfirmModal: FC<ConfirmModalProps> = (props) => {
  const {
    title,
    visible,
    confirmContent = "Okay",
    confirmButtonAppearance = Buttons.Functional.Primary.Large,
    onClose,
    children,
    testId,
    size,
    id,
  } = props;

  const confirmButtonTestId = testId ? `${testId}-confirm-btn` : undefined;

  return (
    <Modal
      id={id}
      title={title}
      visible={visible}
      onClose={onClose}
      testId={testId}
      size={size}
      footer={
        <Shelf>
          <Shelf.Spacer />
          <Button appearance={confirmButtonAppearance} onClick={onClose} testId={confirmButtonTestId} autoFocus>
            {confirmContent}
          </Button>
        </Shelf>
      }
    >
      {children}
    </Modal>
  );
};
